import React, { useState } from "react"
import { Modal, Alert, Typography } from "antd"
import Strings from "utils/strings"

const { Text } = Typography

interface ZoneDeleteModalProps {
	visible: boolean
	// The zone being deleted (null while closed).
	zone: any | null
	// Whether the zone is currently used for delivery-area validation.
	inUse: boolean
	// Server-side refusal to show in place of the usual notice, e.g. a global
	// zone still referenced by contracts the caller cannot see.
	error?: string | null
	onClose: () => void
	// Performs the deletion; the modal shows a loading state until it resolves.
	onConfirm: () => Promise<void>
}

const ZoneDeleteModal: React.FC<ZoneDeleteModalProps> = ({
	visible,
	zone,
	inUse,
	error = null,
	onClose,
	onConfirm,
}) => {
	const [deleting, setDeleting] = useState(false)

	const handleConfirm = async () => {
		setDeleting(true)
		try {
			await onConfirm()
		} finally {
			setDeleting(false)
		}
	}

	return (
		<Modal
			title={Strings.contracts.geojsonDeleteTitle}
			visible={visible}
			onCancel={onClose}
			onOk={handleConfirm}
			okText={Strings.generic.confirm}
			cancelText={Strings.generic.cancel}
			okButtonProps={{ danger: true, loading: deleting, disabled: !!error }}
			cancelButtonProps={{ disabled: deleting }}
			width={480}
			destroyOnClose
		>
			<p>
				<Text>
					{Strings.contracts.geojsonDeleteMessage.replace(
						"{name}",
						zone?.name || ""
					)}
				</Text>
			</p>

			<Alert
				type={error ? "error" : inUse ? "warning" : "info"}
				showIcon
				message={
					error ||
					(inUse
						? Strings.contracts.geojsonDeleteInUseWarning
						: Strings.contracts.geojsonDeleteNotInUse)
				}
			/>
		</Modal>
	)
}

export default ZoneDeleteModal
